import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import type { ObConfigAuth, OverallOutcome } from '@onefootprint/types';
import type { DeviceInfo } from '@/idv/hooks';
import type { BootstrapData, DIMetadata } from '@/idv/types';
import type { State } from './utils/reducer';

export type LogoConfig = { orgName: string; logoUrl?: string };

export type InitArgs = {
  initialAuthToken?: string;
  isComponentsSdk?: boolean;
  bootstrapData?: BootstrapData;
  config?: OnboardingSessionConfig;
  isLive: boolean;
  device: DeviceInfo;
  obConfigAuth?: ObConfigAuth;
  sandboxId?: string;
  overallOutcome?: OverallOutcome;
  logoConfig?: LogoConfig; // When provided, will render the logo
  variant: IdentifyVariant;
};

export enum IdentifyVariant {
  auth = 'auth',
  updateLoginMethods = 'updateLoginMethods',
  verify = 'verify',
}

export type DoneArgs = {
  authToken: string;
  phoneNumber?: DIMetadata<string>;
  email?: DIMetadata<string>;
  isPasskeyRegistered?: boolean;
};

export type Context = {
  state: State;
  onError: (location: string, error: unknown) => void;
  // Bootstrap data could be cleared out once the machine is initialized, so don't allow reading it from initArgs
  initArgs: Omit<InitArgs, 'bootstrapData'>;
};

export type ObKeyHeader = { 'X-Onboarding-Config-Key': string };
